import Axios from "@/plugins/Axios";

export class PresencasService {
  async listPresencasNotifiq() {
    const response = await Axios().get("notifiq/presencas");
    return response.data;
  }

  async getPresencasNotifiqHikvision(dateOrPayload, horario_id = null, turma_id = null) {
    const payload =
      typeof dateOrPayload === "object"
        ? dateOrPayload
        : { date: dateOrPayload, horario_id, turma_id };

    const hasHorarioId = !!payload.horario_id;
    const hasHorarioIds = Array.isArray(payload.horario_ids) && payload.horario_ids.length > 0;

    if (!payload.date || (!hasHorarioId && !hasHorarioIds) || !payload.turma_id) {
      throw new Error(
        "Parâmetros insuficientes: date, turma_id e horario_id/horario_ids são necessários."
      );
    }

    const response = await Axios().post("notifiq/presencas/get-presencas-hikvision", payload, {
      timeout: 15000,
    });

    return response.data;
  }

  async getPresencasHikvision(params) {
    const response = await Axios().get("notifiq/presencas/presencas-hikvision", { params });
    return response.data;
  }
}

export default new PresencasService();
